<template>
    <div class="collapsible">
        <div class="trigger">
            <div class="row align-items-center">
                <div class="col-auto">
                    <div class="trigger-icon">
                        <svg class="fillall" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                    </div>
                </div>
                <div class="col">
                    <div class="trigger-content">Integración de Medios</div>
                </div>
                <!--<div class="col-auto touchpad" @click="collapse">
                    <div class="trigger-indicator">
                        <font-awesome-icon v-if="hide" icon="chevron-down" style="color:#fff; height:24px"/>
                        <font-awesome-icon v-else icon="chevron-up" style="color:#fff; height:24px"/>
                    </div>
                </div>-->
            </div>
        </div>
        <!--<div :class="['body',{'hide':hide}]">-->
        <div class="body">
            <div class="row"> 
                <div class="col-sm-12 col-md-6 "  v-for="red in redes" :key="red.id">
                    <div class="card social-media">
                        <div class="card-content">
                            <div class="container">
                                <div class="row element">
                                    <div class="col-auto content-col">
                                        <p class="paragraph">{{red.name}}</p>
                                    </div>
                                    <div class="col content-col">
                                        <p class="paragraph">{{red.type}}</p>
                                    </div>
                                    <div class="col-auto content-col">
                                        <!--<div class="row">
                                            <svg class="fillall" xmlns="http://www.w3.org/2000/svg" width="4" height="24" viewBox="0 -2 4 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <circle data-name="Elipse 3" class="cls-1" cx="1.5" cy="1.5" r="1.5"/>
                                                <circle data-name="Elipse 3 copia" class="cls-1" cx="1.5" cy="8.5" r="1.5"/>
                                                <circle data-name="Elipse 3 copia 2" class="cls-1" cx="1.5" cy="15.5" r="1.5"/>
                                            </svg>
                                        </div>-->
                                    </div>
                                </div>
                                <div class="row element action">
                                    <div class="col-auto content-col">
                                        <button class="button small" @click="check(red.id)">
                                            <span>{{red.titulo}}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- card -->
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'adminRedes',
    data () {
        return {
            url : this.$store.getters.getMainUrl,
            isLoading:false,
            redes:[],
            redesDefault:[
                {
                    name:'Televisión',
                    id:'T',
                    titulo:'Administrar Noticieros',
                    type:'Offline'
                },
                {
                    name:'Radio',
                    id:'R',
                    titulo:'Administrar Noticieros',
                    type:'Offline'
                },
                {
                    name:'Facebook',
                    id:'FB',
                    titulo:'Administrar Páginas',
                    type:'Online'
                },
                {
                    name:'Twitter',
                    id:'TW',
                    titulo:'Administrar Cuentas',
                    type:'Online'
                },
                {
                    name:'Youtube',
                    id:'Y',
                    titulo:'Administrar Canales',
                    type:'Online'
                },
              /*  {
                    name:'Instagram',
                    id:'I',
                    titulo:'Administrar Cuentas',
                    type:'Online'
                },*/
                {
                    name:'Periódicos Digitales',
                    id:'PD',
                    titulo:'Administrar URLS',
                    type:'Online'
                },
                {
                    name:'Tiktok',
                    id:'TK',
                    titulo:'Administrar URLS',
                    type:'Online'
                }
            ],
            hide:false
        }
    },
    async beforeMount(){
        console.log('beforeMpunt');
        var r = await this.getPermisosFeeds();
        console.log(r);
        if(r.success){
           for(var i in r.data){
               var index = r.data[i];
               console.log(i);
               var obj = this.redesDefault.find( red => red.id === r.data[i] );
               console.log(obj);
               if(obj!=undefined)
               this.redes.push(obj);
           }
           if(this.redes.length==0){
               this.redes = this.redesDefault;
           }
        }else{
            this.error(r.error);
        }
    },
    computed:{
        token(){
            return this.$store.getters.getToken;
        }
    },
    methods:{
        async check(id){
            this.goTo(id);
        },
        goTo(id){
            this.isLoading = true;
            switch(id){
                case 'T':
                case 'R':
                    this.$router.push({name:'noticieros',params:{id:id}})
                break;
                default : this.$router.push({name:'redes',params:{id:id}})
                break;
            }
        },
        // ------------- LOGIN GOOGLE ------------
        /*async login (id) {
            var self = this;
            var gapi = await this.$gapi.getGapiClient();
            
                gapi.load('auth2', async function() {
                    var auth2 = await gapi.auth2.init({
                        client_id: self.$store.state.client_id,
                        scope: 'https://www.googleapis.com/auth/youtube'
                    });
                    if (!auth2.isSignedIn.get()) { // check if already signed in
                        auth2.signIn({
                            scope: 'https://www.googleapis.com/auth/youtube',
                            access_type:'access_token'
                        }).then(async function(googleUser) {
                            console.log(googleUser)
                            var access_token = googleUser.Zi.access_token;
                            console.log('user signed in')
                            var token_ok = await self.verifyToken(access_token);
                            if(token_ok.success){
                                self.$store.commit('updateAccessToken',access_token);
                                self.goTo(id);
                            }
                            
                        }, function(error) {
                            console.log('user failed to sign in');
                            console.log(error);
                        })
                    }else{
                        var user = auth2.currentUser.get();
                        var access_token = user.Zi.access_token;
                        self.$store.commit('updateAccessToken',access_token);
                        console.log(id);
                        self.goTo(id);
                    }                
                })        
        },
        verifyToken(access_token){
            return new Promise((resolve,reject)=>{
                var url = "https://www.googleapis.com/oauth2/v1/tokeninfo?access_token="+access_token
                axios.get(url) //petición
                .then((response)=>{
                    console.log(response)
                    if(response.error){
                        resolve({success:false,error:response.error})
                    }else{
                        resolve({success:true,data:response})
                    }
                }).catch((error)=>{
                    resolve({success:false,error:error})
                });
            })
            
        },*/
        // ------------- LOGIN TWITTER ------------
        async loginTW (id) {
            var isSignedTwitter= await this.isSignedTwitter();   
            if(isSignedTwitter.success){
                this.goTo(id);
            }else{ //obtenemos credenciales
                var r = await this.signInTwitter();
                console.log(r);
                if(r.success){
                    var r2 = await this.updateInfoUser(r.data);
                    console.log(r2);
                    if(r2.success){
                        this.goTo(id);
                    }else{
                        this.isLoading = false;
                        console.log(r2)
                        this.error(r2.error);
                    }
                }else{
                    this.isLoading = false;
                }
            }
        },
        async isSignedTwitter(){
            var self = this;
            return new Promise((resolve,reject)=>{
                axios.post(self.url+'isSignedTwitter', JSON.stringify({token:this.token}))
                .then((response)=>{
                    resolve(response);
                })
                .catch(function (error) {
                    resovle({success:false,error:error})
                });
            })
            
        },
        signInTwitter(){
            return new Promise((resolve,reject)=>{
               
            })    
        },
        async updateInfoUser(data){
            var post_data = {
                cmd:'updateInfoUser',
                data:{
                    token:this.token,
                    user: {
                        utoken:data.utoken,
                        usecret:data.usecret
                    }
                }
            }
            var self = this;
            return new Promise((resolve,reject)=>{
                axios.post(self.url+'UsersBdtr', JSON.stringify(post_data))
                .then((response)=>{
                    resolve(response);
                })
                .catch(function (error) {
                    resovle({success:false,error:error})
                });
            })
        },
        success(msg){
            this.$snotify.clear();
            this.$snotify.success(msg, this.$store.state.success);
        },
        error(msg){
            this.$snotify.clear();
            this.$snotify.error(msg, this.$store.state.error);
        },
        collapse(){
            this.hide = !this.hide;
        },
        async getPermisosFeeds(){
            var self = this;
            return new Promise(resolve=>{
                axios.post(this.url+'getPermisosFeeds', JSON.stringify({token:self.token})) //petición
                .then((response)=>{
                self.isLoading = false;
                resolve(response.data);
                })
                .catch(function (error) {
                self.isLoading = false;
                var response = {success:false,error:error}
                console.log(error);
                resolve(response);
                });
            });
        },
    }
}
</script>